"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKonfektionierung10 = exports.konfektionierung10UseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../../ArticleBase");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.konfektionierung10UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.konfektionierung,
    },
};
exports.isKonfektionierung10 = echain_shared_modelling_1.UseableUtil.createGuard(exports.konfektionierung10UseableDef);
//# sourceMappingURL=Konfektionierung10.js.map